//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { Box, Button, Grid, Typography, useTheme } from '@mui/material'
import React from 'react'
import LenderInvestmentListSummary from './LenderInvestmentListSummary'
import LenderPoolOpenings from './LenderPoolOpenings'
import LenderPortfolioSummary from './LenderPortfolioSummary'

import Paper from '@mui/material/Paper'
import { useOtChainState } from '@react/redux/store'
import { REPORT_FETCH_DESCRIPTOR_TRANSACTION_LIST } from '@react/reporting/ReportDescriptors'
import ReportRowGenerator from '@react/reporting/ReportRowGenerator'
import { ZeroAddress } from 'ethers'
import { Link } from 'react-router-dom'

export default function LenderHome(): React.ReactElement {
  const theme = useTheme()
  const {
    userConnection: { accountAddr },
  } = useOtChainState()
  return (
    <Grid container spacing={0} justifyContent="flex-start" direction={'column'} style={{ maxWidth: '100%' }}>
      <Grid item key="LS1 " style={{ maxWidth: '100%' }}>
        <LenderPortfolioSummary />
      </Grid>
      <Grid item key="list" style={{ maxWidth: '100%' }}>
        <LenderInvestmentListSummary limit={4} />
      </Grid>
      <Grid key="openings" item style={{ maxWidth: '100%' }} sx={{ marginTop: 4, marginBottom: 4 }}>
        <Box
          sx={{
            marginTop: 4,
            marginBottom: 4,
          }}
        >
          <LenderPoolOpenings limit={4} />
        </Box>
      </Grid>
      <Grid key="buttons" item style={{ maxWidth: '100%' }} alignItems="flex-start">
        <Paper
          sx={{
            marginTop: 4,
            marginBottom: 4,
            padding: '24px',
            borderRadius: 4,
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box>
              <Typography align="left" sx={{ display: 'inline', float: 'left', fontWeight: 'bold' }} variant={'h4'}>
                Recent Transaction History
              </Typography>
              <Button
                variant="text"
                component={Link}
                to={'/transactions'}
                sx={{ display: 'inline', float: 'right', color: theme.palette.primary.main }}
              >
                <Typography sx={{ color: theme.palette.accent1.emphasis }} variant={'bodyBold'}>
                  View All
                </Typography>
              </Button>
            </Box>
          </Box>
          <Box sx={{}}>
            <ReportRowGenerator
              reportDescriptor={REPORT_FETCH_DESCRIPTOR_TRANSACTION_LIST}
              initialLoadWithoutRefresh={true}
              poolAddr={ZeroAddress}
              lenderAddr={accountAddr}
              numberOfDays={30}
            />
          </Box>
        </Paper>
      </Grid>
    </Grid>
  )
}
